import {
    GET_REPORT_SETUP_CONFIG_SUCCESS,
    GET_REPORT_SETUP_CONFIG_FAILED,
    GET_REPORT_SETUP_CONFIG_STARTED,
} from '../../../constants';
import { GET_REPORT_SETUP_CONFIG } from '../../../../../config/constants';
import { withType } from '../../../../utils/actionOperations';
import { ApiBase } from '../../../../utils/apiBase';
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';

export const getReportSetupConfig = (payload, cb) => {
    const apiBaseInstance = new ApiBase();
    return (dispatch) => {
        dispatch(withType(GET_REPORT_SETUP_CONFIG_STARTED));
        apiBaseInstance.instance
            .post(GET_REPORT_SETUP_CONFIG, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then((response) => {
                dispatch(
                    withType(GET_REPORT_SETUP_CONFIG_SUCCESS, response.data && response.data.data && response.data.data)
                );
                cb && cb(true, response.data && response.data.data && response.data.data);
            })
            .catch((err) => {
                cb && cb(false);
                dispatch(
                    withType(GET_REPORT_SETUP_CONFIG_FAILED, {
                        error: err,
                    })
                );
            });
    };
};
